import styled, { css } from 'styled-components'

const mosaicLayout = {
  1: css`
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr);
  `,
  2: css`
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: repeat(2, minmax(0, 1fr));
  `,
  3: css`
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: repeat(2, minmax(0, 1fr));

    > :last-child {
      grid-column: 1 / -1;
    }
  `,
  4: css`
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: repeat(2, minmax(0, 1fr));
  `
}

export const Cover = styled.div`
  aspect-ratio: 1;
  background: #141414;
  border-radius: 5px;
  display: grid;
  height: 100%;
  overflow: hidden;
  width: 100%;

  ${({ $count }) => mosaicLayout[$count]}
`

export const CoverImage = styled.img`
  display: block;
  height: 100%;
  min-height: 0;
  min-width: 0;
  object-fit: cover;
  width: 100%;
`

export const EmptyCover = styled.div`
  align-items: center;
  aspect-ratio: 1;
  background: #141414;
  border: 1px solid #222222;
  border-radius: 5px;
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: hidden;
  width: 100%;
`

export const ImageFallback = styled.div`
  align-items: center;
  background: #141414;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 0;
  min-width: 0;
  width: 100%;
`

export const IconCircle = styled.div`
  align-items: center;
  background: #4f4e4e;
  border-radius: 50%;
  display: flex;
  height: ${({ $compact }) => ($compact ? '40px' : '64px')};
  justify-content: center;
  width: ${({ $compact }) => ($compact ? '40px' : '64px')};

  svg {
    height: ${({ $compact }) => ($compact ? '20px' : '32px')};
    width: ${({ $compact }) => ($compact ? '20px' : '32px')};
  }
`
